(async function(algolia) {
    'use strict';

    var algoliasearch = algolia.externals.algoliasearch;
    const getAlgoliaResults = algolia.externals.getAlgoliaResults;
    const { config, translations, headerTemplate, productCard, footerTemplate } = algolia;
    const client = algoliasearch(algolia?.config?.app_id, algolia?.config?.search_api_key);
    const index = client.initIndex(algolia?.config?.index_prefix+'products');
    // Filters for stock policy
    let stockPolicyFilter = '';
  
    if (algolia.config.stock_policy === 'deny') {
      // For 'deny' we will filter out all items based on inventory quantity
      stockPolicyFilter = 'inventory_quantity > 0';
    } else if (algolia.config.stock_policy === 'continue') {
      /**
       * For 'continue' we will filter on `inventory_available` attribute whose
       * value is dependent on:
       * `inventory_quantity > 0 OR inventory_policy == 'continue'`
       */
      stockPolicyFilter = 'inventory_available:true';
    }
  
    const index_suffix = await config.index_suffix;
  
    algolia.productsPlugin = {
      getSources({ query, setContext }) {
        if(algolia.queryThreshold && query.length < algolia.queryThreshold) return[]//user needs to input atleast three characters before calling the search api
          return [
            {
              sourceId: 'products',
              getItems() {
                return getAlgoliaResults({
                  searchClient: algolia.searchClient,
                  queries: [
                    {
                      indexName: config.index_prefix + 'products',
                      query,
                      params: {
                        hitsPerPage: config.products_autocomplete_hits_per_page,
                        clickAnalytics: config.analytics_enabled,
                        filters: stockPolicyFilter,
                        ruleContexts: ["search_results"],
                        analyticsTags:["autocomplete"],
                      },
                    },
                  ],
                  transformResponse({ results, hits }) {
                    algolia.updateDistinctPrices(results[0].hits,index,'autocomplete');
                    setContext({
                      nbProducts: results[0].nbHits,
                      products: results[0].hits,
                    });
                    return hits;
                  },
                });
              },
              templates: {
                header({ html, state }) {
                  const resource = translations.products;
                  return headerTemplate({ html, state }, resource);
                },
                item({ item, html, components }) {
                  item.queryID = item.__autocomplete_queryID;
                  item.index = item.__autocomplete_indexName;
                  return productCard(html,item);
                },
                footer({ state, html }){
                  const {autocomplete_see_all, products_autocomplete_hits_per_page} = config;
                  const showFooter = autocomplete_see_all && state.context.nbProducts > products_autocomplete_hits_per_page
                  return showFooter && footerTemplate({ html, state });
                },
              },
            }
          ];
      },
    }
  })(window.algoliaShopify);
  